import React from 'react';
import { T } from './orders.theme';
import { COPY } from './orders.copy';
import { CheckIcon } from './OrdersIcons';
import { PulsingDots } from './OrderStatusPill';

/**
 * The row's only control: Pay.
 *
 * It appears while an order is pending and disappears the moment it is
 * settled. Reversing a payment is rare and consequential, so it does not sit
 * in the list at all — it lives in the order's own screen alongside Edit and
 * Cancel.
 *
 * An invoice order never shows it: an invoice settles against the customer's
 * book through a transaction, not by flipping a status field.
 */
export default function OrderStatusToggle({ entry, busy, onToggle, disabled }) {
  const payable = !entry.isInvoice && !entry.isCanceled && entry.isPending;

  if (!payable) {
    // An empty cell, not a missing one — the column has to hold its width or
    // every total in the list stops lining up.
    return <span />;
  }

  if (busy) {
    return (
      <span style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            background: T.paid,
            borderRadius: T.radiusSmall,
            padding: '9px 18px',
          }}
        >
          <PulsingDots />
        </span>
      </span>
    );
  }

  const handleClick = (event) => {
    // The row itself opens the detail panel; Pay must not.
    event.stopPropagation();
    if (!disabled) onToggle(entry);
  };

  return (
    <span style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <button
        type="button"
        onClick={handleClick}
        disabled={disabled}
        title={`${COPY.pay} #${entry.orderNumber}`}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 5,
          background: T.paid,
          border: 'none',
          borderRadius: T.radiusSmall,
          padding: '6px 14px',
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.5 : 1,
          font: 'inherit',
          whiteSpace: 'nowrap',
        }}
      >
        <CheckIcon size={13} color={T.surface} width={2.6} />
        <span style={{ fontSize: 11.5, fontWeight: 700, color: T.surface }}>{COPY.pay}</span>
      </button>
    </span>
  );
}
